module.exports = __webpack_public_path__ + "img/help.392bd205.svg";